import React, { useState } from 'react';

function CustomPrompt({ isOpen, onClose, onSave, message }) {
  const [inputValue, setInputValue] = useState('');

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSave = () => {
    onSave(inputValue);
    setInputValue('');
  };

  const handleBackgroundClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal" onClick={handleBackgroundClick}>
      <div className="modal-content">
        {message ? (
          <div>
            <h2>{message}</h2>
            <button onClick={onClose} className="bg-blue">OK</button>
          </div>
        ) : (
          <div>
            <h2>プロジェクト名を入力してください</h2>
            <input
              type="text"
              value={inputValue}
              onChange={handleChange}
              className="project-input"
              placeholder="プロジェクト名"
            />
            <div className="button-row">
              <button onClick={handleSave} className="bg-blue">保存</button>
              <button onClick={onClose} className="bg-gray">キャンセル</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomPrompt;
